import { render, staticRenderFns } from "./PackageSingleTrendChart.vue?vue&type=template&id=2db737ce&scoped=true"
import script from "./PackageSingleTrendChart.vue?vue&type=script&lang=js"
export * from "./PackageSingleTrendChart.vue?vue&type=script&lang=js"
import style0 from "./PackageSingleTrendChart.vue?vue&type=style&index=0&id=2db737ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db737ce",
  null
  
)

export default component.exports